import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { colors } from '@guryou/colors';
import { ServiceTypes } from '@guryou/core/build/entity';
import { DefaultText, FullScreenSpinner } from '@guryou/html-components';
import { stateIsLoading } from '@guryou/redux';
import { WidgetContext } from './WidgetContext';
import WidgetMemberships from './WidgetMemberships';
import WidgetNotPaidFor from './WidgetNotPaidFor';
import WidgetServices from './WidgetServices';
import WidgetVideos from './WidgetVideos';

const Widget = () => {
  const { t } = useTranslation();
  const {
    activeTab,
    setActiveTab,
    showEvents,
    showVideos,
    showCourses,
    showServices,
    showMemberships,
    plan,
    services,
    courses,
    memberships,
  } = useContext(WidgetContext);

  const videos = useSelector(state => state.widget.videos);
  const tabsLength = [showEvents, showVideos, showCourses, showServices, showMemberships].filter(x => x).length;
  if (!tabsLength) {
    return <DefaultText>{t('BOOK_WIDGET.configurationWidg')}</DefaultText>;
  }

  if (plan.id === 0) {
    return <WidgetNotPaidFor />;
  }

  if (tabsLength === 1) {
    if (showServices || showCourses || showEvents) {
      return <WidgetServices />;
    }
    if (showMemberships) {
      return <WidgetMemberships />;
    }
    return <WidgetVideos />;
  }

  if (!activeTab && (stateIsLoading([services]) || stateIsLoading([courses]) || stateIsLoading([videos]))) {
    return <FullScreenSpinner />;
  }

  return (
    <main>
      <header class="w-full mt-8 items-center justify-center flex mb-8">
        <div class="mb-4">
          <ul class="flex flex-wrap -mb-px text-sm font-medium text-center">
            {showServices && services.data?.length ? (
              <li class="me-2" onClick={() => setActiveTab('service')}>
                <button
                  style={{ borderColor: activeTab === 'service' && colors.mandy }}
                  class={`inline-block p-4 border-red-950 rounded-t-lg ${activeTab === 'service' && 'border-b-2'}`}
                >
                  <p class="capitalize">{t('SERVICES.titlePlural').toLocaleLowerCase()}</p>
                </button>
              </li>
            ) : null}
            {showCourses && courses.data?.filter(c => c.serviceType === ServiceTypes.course).length ? (
              <li class="me-2" onClick={() => setActiveTab('course')}>
                <button
                  style={{ borderColor: activeTab === 'course' && colors.mandy }}
                  class={`inline-block p-4 border-red-950 rounded-t-lg ${activeTab === 'course' && 'border-b-2'}`}
                >
                  <p class="capitalize">{t('COURSES.titlePlural').toLocaleLowerCase()}</p>
                </button>
              </li>
            ) : null}
            {showVideos && videos.data?.length ? (
              <li class="me-2" onClick={() => setActiveTab('video')}>
                <button
                  style={{ borderColor: activeTab === 'video' && colors.mandy }}
                  class={`inline-block p-4 border-red-950 rounded-t-lg ${activeTab === 'video' && 'border-b-2'}`}
                >
                  <p class="capitalize">{t('PRODUCT_VIDEO.titlePlural').toLocaleLowerCase()}</p>
                </button>
              </li>
            ) : null}
            {showMemberships && memberships?.length ? (
              <li class="me-2" onClick={() => setActiveTab('membership')}>
                <button
                  style={{ borderColor: activeTab === 'membership' && colors.mandy }}
                  class={`inline-block p-4 border-red-950 rounded-t-lg ${activeTab === 'membership' && 'border-b-2'}`}
                >
                  <p class="capitalize">{t('MEMBERSHIPS.titlePlural').toLocaleLowerCase()}</p>
                </button>
              </li>
            ) : null}
            {showEvents && courses.data?.filter(c => c.serviceType === ServiceTypes.event).length ? (
              <li class="me-2" onClick={() => setActiveTab('event')}>
                <button
                  style={{ borderColor: activeTab === 'event' && colors.mandy }}
                  class={`inline-block p-4 border-red-950 rounded-t-lg ${activeTab === 'event' && 'border-b-2'}`}
                >
                  <p class="capitalize">{t('EVENTS.titlePlural').toLocaleLowerCase()}</p>
                </button>
              </li>
            ) : null}
          </ul>
        </div>
      </header>
      <session>{activeTab === 'service' && <WidgetServices />}</session>
      <session>{activeTab === 'course' && <WidgetServices courseView={true} />}</session>
      <session>{activeTab === 'video' && <WidgetVideos />}</session>
      <session>{activeTab === 'membership' && <WidgetMemberships />}</session>
      <session>{activeTab === 'event' && <WidgetServices eventView={true} />}</session>
    </main>
  );
};

export default Widget;
